import React from "react";
import Card from "./Card";

const Cards = ({ sectionId, entityId, data, currencyCode }) => {
  return (
    <React.Fragment>
      {data.length > 0 ? (
        <div className="sg-grid-cards matching-gifts-cards">
          {data.map((matchingGift) => (
            <div className="sg-grid-card matching-gift-card" key={matchingGift.id}>
              <Card
                entityId={entityId}
                campaign={matchingGift.campaign}
                sectionId={sectionId}
                currencyCode={currencyCode}
                matchingGift={matchingGift}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <div className="no-image">
            <i className="fa fa-search fa-5x" />
            <span>No Results</span>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Cards;
